__turbopack_context__.v({
  "cookie-buttons": "CookieComponent-module-scss-module__-oTkyq__cookie-buttons",
});
